import { render, staticRenderFns } from "./TheDocuments.vue?vue&type=template&id=aa0d6782&"
import script from "./TheDocuments.vue?vue&type=script&lang=js&"
export * from "./TheDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports